import styled from "styled-components";
export const TopDown = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
`;
